import React, { useState, useEffect } from 'react';
import { useLocation, useNavigate, useParams } from 'react-router-dom';
import ProductForm from '../../../components/admin/ProductForm';
import '../../../styles/vendeurs/EditProduit.css';
import {
  fetchProduitById,
  fetchCategories,
  fetchTitresByCategorie,
  modifierProduit,
} from '../../../services/vendeurs/produitService';
import { asset } from '../../../services/api';

function EditProduit() {
  const location = useLocation();
  const navigate = useNavigate();
  const { id } = useParams();
  const vendeur = JSON.parse(localStorage.getItem('vendeurConnecte'));

  const [formData, setFormData] = useState(null);
  const [categories, setCategories] = useState([]);
  const [titresOptions, setTitresOptions] = useState([]);
  const [imagePreview, setImagePreview] = useState(null);

  useEffect(() => {
    const load = async () => {
      try {
        const produit = location.state || await fetchProduitById(id);

        const completeForm = {
          id: produit.id,
          categorie_id: produit.categorie_id || '',
          titre_id: produit.titre_id || '',
          description: produit.description || '',
          description_detaillee: produit.description_detaillee || '',
          price: produit.price || '',
          stock: produit.stock || '',
          img: produit.img || null,
          lieu: produit.lieu || '',
          unite: produit.unite || 'kg',
          quantite_min: produit.quantite_min || ''
        };

        setFormData(completeForm);
        setImagePreview(
          typeof completeForm.img === 'string' ? asset(completeForm.img) : null
        );

        const cats = await fetchCategories();
        setCategories(cats);
      } catch (err) {
        alert("Erreur lors du chargement du produit.");
        navigate('/vendeur/produits');
      }
    };

    load();
  }, [id, location.state, navigate]);

  useEffect(() => {
    if (formData?.categorie_id) {
      fetchTitresByCategorie(formData.categorie_id)
        .then(setTitresOptions)
        .catch(() => setTitresOptions([]));
    }
  }, [formData?.categorie_id]);

  const handleChange = (e) => {
    const { name, value, files } = e.target;

    if (name === 'img' && files?.[0]) {
      const file = files[0];
      setImagePreview(URL.createObjectURL(file));
      setFormData(prev => ({ ...prev, img: file }));
    } else {
      setFormData(prev => ({ ...prev, [name]: value }));
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    const data = new FormData();
    for (let key in formData) {
      if (formData[key] !== null && formData[key] !== undefined) {
        data.append(key, formData[key]);
      }
    }
    data.append('vendeur_id', vendeur.id);

    try {
      await modifierProduit(formData.id, data);
      alert('✅ Produit modifié avec succès');
      navigate('/vendeur/produits');
    } catch (err) {
      console.error(err);
      alert("❌ Erreur lors de la modification");
    }
  };

  if (!formData) return <p>Chargement...</p>;

  return (
    <div className="edit-produit-container">
      <h2>✏️ Modifier Produit</h2>

     <div className="image-edit-block">
      <div className="image-wrapper">
        {imagePreview ? (
          <img src={imagePreview} alt="Aperçu produit" className="image-preview" />
        ) : (
          <div className="image-placeholder">Aucune image</div>
        )}
        <label htmlFor="fileInput" className="edit-icon">✏️</label>
      </div>

      <input
        type="file"
        id="fileInput"
        name="img"
        accept="image/*"
        style={{ display: 'none' }}
        onChange={handleChange}
      />
    </div>

      <ProductForm
        formData={formData}
        handleChange={handleChange}
        handleSubmit={handleSubmit}
        categories={categories}
        titresOptions={titresOptions}
      />
    </div>
  );
}

export default EditProduit;
